/**
 * Legal URL constants for terms, privacy, and compliance links
 */
export const LEGAL_URLS = {
  termsOfService: 'https://www.masterclass.com/terms',
  aiTerms: 'https://learn.masterclass.com/ai-terms',
  smsTerms: 'https://learn.masterclass.com/sms-terms',
  privacyPolicy: 'https://privacy.masterclass.com/policies',
  privacyCenter: 'https://privacy.masterclass.com/',
  speechToTextNotice:
    'https://privacy.masterclass.com/policies?name=speech-to-text-notice',
  privacy: 'https://www.masterclass.com/privacy',
  nonAccreditedInfo:
    'https://www.masterclass.com/terms/non-accredidation-MCExec',
  refundsInfo: 'https://www.masterclass.com/terms/MCX-Refunds',
  boothMemberTerms:
    'https://www.masterclass.com/terms/mcx-loyalty-chicago-booth-2026',
} as const
